var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68605 0C3.29321 0 2.16279 1.10043 2.16279 2.45946V19.6757H1.0814C0.484465 19.6757 0 20.1479 0 20.7297V24.9459C0 25.5278 0.484465 26 1.0814 26H12.6163C13.2132 26 13.6977 25.5278 13.6977 24.9459V20.7297C13.6977 20.1479 13.2132 19.6757 12.6163 19.6757H10.814V11.9459H28.4767C29.871 11.9459 31 10.8441 31 9.48649V5.27027C31 3.91265 29.871 2.81081 28.4767 2.81081H10.814V2.45946C10.814 1.10043 9.68353 0 8.2907 0H4.68605ZM4.68605 2.10811H8.2907C8.48967 2.10811 8.65116 2.26551 8.65116 2.45946V3.86486V10.8919V19.6757H4.32558V2.45946C4.32558 2.26551 4.48707 2.10811 4.68605 2.10811ZM10.814 4.91892H16.066L14.0469 9.83784H10.814V4.91892ZM18.395 4.91892H23.2753L21.2562 9.83784H16.3758L18.395 4.91892ZM25.6043 4.91892H28.4767C28.6757 4.91892 28.8372 5.07632 28.8372 5.27027V9.48649C28.8372 9.68043 28.6757 9.83784 28.4767 9.83784H23.5851L25.6043 4.91892ZM6.48837 5.97297C6.10597 5.97297 5.73922 6.12104 5.46882 6.38461C5.19842 6.64817 5.04651 7.00564 5.04651 7.37838C5.04651 7.75111 5.19842 8.10859 5.46882 8.37215C5.73922 8.63571 6.10597 8.78378 6.48837 8.78378C6.87078 8.78378 7.23752 8.63571 7.50792 8.37215C7.77832 8.10859 7.93023 7.75111 7.93023 7.37838C7.93023 7.00564 7.77832 6.64817 7.50792 6.38461C7.23752 6.12104 6.87078 5.97297 6.48837 5.97297ZM2.16279 21.7838H3.24419H9.73256H11.5349V23.8919H2.16279V21.7838Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGate);
export default __webpack_public_path__ + "static/media/gate.e28a86ba322c94ad7281f615a008f1a7.svg";
export { ForwardRef as ReactComponent };